import { api } from '../api/client.js';

// JR/JCH — Zařazení do úrovně (level assignment). Talks to /api/v1/maklerOverview
// (the makler list) and /api/v1/makler/:id/level (detail, assign, suggest).

export function listMaklers() {
  return api.get('/maklerOverview').then((r) => r.data.data.maklers);
}

export function getLevelDetail(maklerId) {
  return api
    .get(`/makler/${maklerId}/level`)
    .then((r) => r.data.data);
}

export function assignLevel(maklerId, payload) {
  return api
    .post(`/makler/${maklerId}/level`, payload)
    .then((r) => r.data.data);
}

export function suggestLevel(maklerId, payload) {
  return api
    .post(`/makler/${maklerId}/level/suggest`, payload)
    .then((r) => r.data.data);
}
